import { apiClient } from '../httpClient';
import { handleApiError } from '../utils/errorHandler';

const ISSUANCE_LIST_PATH = '/java/sales/invoice/v1/issuance_list';
const ISSUANCE_SUMMARY_PATH = '/java/sales/invoice/v1/issuance_list/summary';

/**
 * POST /invoice/v2/invoice/list_with_items_by_sub_order_id_list
 * Body: FastAPI `List[int]` — JSON 배열 그대로 전송 (예: [1, 2, 3])
 * (타 화면 호환용 — Invoice Issuance 목록은 issuance_list 사용)
 */
export const invoiceIssuanceService = {
  getInvoicesWithItemsBySubOrderIdList: async (subOrderIdList) => {
    try {
      if (!subOrderIdList?.length) {
        return { success: true, data: [] };
      }
      const response = await apiClient.post(
        '/invoice/v2/invoice/list_with_items_by_sub_order_id_list',
        subOrderIdList
      );
      return { success: true, data: response.data ?? [] };
    } catch (error) {
      return handleApiError(error, 'Failed to load invoices with items');
    }
  },

  /**
   * GET /java/sales/invoice/v1/issuance_list
   * @param {Record<string, unknown>} params
   */
  getIssuanceList: async (params) => {
    try {
      const response = await apiClient.get(ISSUANCE_LIST_PATH, { params });
      return { success: true, data: response.data };
    } catch (error) {
      return handleApiError(error, 'Failed to load invoice issuance list');
    }
  },

  /**
   * GET /java/sales/invoice/v1/issuance_list/summary
   * @param {Record<string, unknown>} params — limit/offset 제외한 목록과 동일 필터
   */
  getIssuanceListSummary: async (params) => {
    try {
      const response = await apiClient.get(ISSUANCE_SUMMARY_PATH, { params });
      return { success: true, data: response.data };
    } catch (error) {
      return handleApiError(error, 'Failed to load invoice issuance summary');
    }
  }
};
